/**
 * Emulates node.getRootNode() without support for the additional options (shadow DOM handling).
 */
export function getRootNodeSimple(element: Node): Node {
    return element?.getRootNode();
}
